/**
 * Created by hernanherreros on 2019-05-03
 */

import * as React from 'react'
import { URLParamsContextInterface } from './URLParamsContext'
import URLParamsContext from './URLParamsContext'

interface Props {
}

class URLParamsProvider extends React.Component<Props, URLParamsContextInterface> {
  constructor (props: Props) {
    super(props)

    this.state = {
      params: {},
    }
  }

  componentWillMount () {
    const url_string = window.location.href
    const url = new URL(url_string)

    const params: any = {}

    for (let pair of url.searchParams.entries()) {
      params[pair[0]] = pair[1]
    }

    this.setState({ params })
  }

  render() {
    const { children } = this.props

    return (
      <URLParamsContext.Provider value={this.state}>
        {children}
      </URLParamsContext.Provider>
    )
  }
}

export default URLParamsProvider